function markUpCalc(rate, increasedAmount) {
  const markUp = rate * (increasedAmount / 100)
  return Number(markUp.toFixed(2))
}
export default markUpCalc
